import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-pi-inline-editor',
	templateUrl: './pi-inline-editor.component.html',
	styleUrls: ['./pi-inline-editor.component.scss']
})
export class PIInlineEditorComponent {
	@Input() element;
	@Input() selectedElementIndex;

	constructor() {}
}
